<template>
  <div>
    <top-navigation-bar></top-navigation-bar>
    <div class='init-chat-bot'>
      <div class="">
        <div class='pl-3'>
          <div style='font-size: 1.75rem; font-weight: 600; color: #a100ff; font-family: Graphik'>
            Hi, {{ firstName }}
          </div>
        </div>
        <div class="pl-3"
             style='margin: 12px 0 20px; color: #100d1b; font-size: 14px; text-align: left; font-family: Graphik'>
          <div>Hello, I’m happy to assist you. I am CSSA.</div>
          <div>
            As your intelligent assistant, I can help you quickly book meeting room or open workspace,
          </div>
          <div>
            create IT tickets, and answer general inquiries and policy-related questions about Accenture.
          </div>
        </div>
        <message-input style="margin-top: 40px" @sendMessage='sendMessage'></message-input>
        <div style="font-size: 12px; text-align: center; font-family: Graphik" class="mt-2">
          Copyright 2001-{{ new Date().getFullYear() }} © Accenture.All rights reserved.Accenture
          Confidential.For
          internal use only.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mdiArrowUpCircle,
  mdiMessageText,
  mdiSend,
  mdiThumbUpOutline,
  mdiArrowUp,
  mdiAttachment,
  mdiFileDocumentOutline,
  mdiCloudUpload,
  mdiWindowClose,
  mdiCogOutline,
} from '@mdi/js'
import MessageInput from '@/modules/chat/view/chatbot/component/MessageInput20250515.vue'
import FeedbackMenu from '@/modules/chat/view/chatbot/component/FeedbackMenu'
import TopNavigationBar from '@/modules/chat/view/chatbot/component/TopNavigationBar'
import { store } from '@/myops/core'

export default {
  components: {
    MessageInput,
    FeedbackMenu,
    TopNavigationBar,
  },
  data() {
    return {
      adminEidList: [
        'jerry.du',
        'deyu.liu',
        'dave.ding',
      ],
      newMessage: null,
      openDeepSeek: false,
      icons: {
        mdiArrowUpCircle,
        mdiMessageText,
        mdiSend,
        mdiThumbUpOutline,
        mdiArrowUp,
        mdiAttachment,
        mdiFileDocumentOutline,
        mdiCloudUpload,
        mdiWindowClose,
        mdiCogOutline,
      },
      modelName: 'DeepSeek-R1-联网满血版',
      adminCogEnter: false,
      eid: store.state.user.user.eid,
    }
  },
  computed: {
    firstName() {
      return store.state.user.user.userExInfo.sapPersonalInfo.firstName || store.state.user.user.eid
    },
    isOpsSuperAdmin() {
      const roleList = store.state.user.user.userExInfo.roleList || []
      return roleList.includes('ops_01') || this.adminEidList.includes(this.eid)
    },
  },
  mounted() {
    this.setModelType('DeepSeek')
  },
  methods: {
    setModelType(modelType) {
      store.commit('chat/SET_MODEL_TYPE', modelType)
    },
    sendMessage(message) {
      this.$emit('sendMessage', message)
    },
  },
}
</script>
<style scoped>
.init-chat-bot {
  margin: 13% auto;
  display: grid;
  place-items: center; /* 同时实现水平和垂直居中 */
  border: none;
}
</style>
